import { BASE_BE_URL } from "../../lib/sessionClient";

//--------------- Site Jursidiction APIs-----------------------------------------
export const HIER_SETUP = BASE_BE_URL + "/hier/setup";
export const ADD_HIER = BASE_BE_URL + "/hier";

//--------------- Site Add APIs-----------------------------------------
export const ADD_SITE = BASE_BE_URL + "/station";
export const SITE_SETUP = BASE_BE_URL + "/station/setup";
export const ALL_SITE_BY_USER = BASE_BE_URL + "/station/all-byuser";
export const UPLOAD_STATION_BULK = BASE_BE_URL + "/station/bulk";
export const SITE_DOWNLOAD_TEMPLATE =
  BASE_BE_URL + "/station/bulk/template";

//--------------- Update Sttions APIs-----------------------------------------
export const UPDATE_SITE = BASE_BE_URL + "/station/update/";
export const UPDATE_SITE_SETUP = BASE_BE_URL + "/station/update/setup";
export const UPDATE_BULK_SITE_TEMPLATE =
  BASE_BE_URL + "/station/update/bulk/template";
export const UPDATE_BULK_STATION = BASE_BE_URL + "/station/update/bulk";

//--------------- Machine and Add Machine APIs-------------------------------------
export const ADD_MACHINE = BASE_BE_URL + "/machine";
export const MACHINE_SETUP = BASE_BE_URL + "/machine/setup";
export const ALL_MACHINE = BASE_BE_URL + "/machine/all";

//--------------- Machine Componenets APIs-----------------------------------------
export const ADD_MACHINE_COMPONENT = BASE_BE_URL + "/machine/component";
export const MACHINE_COMPONENT_SETUP = BASE_BE_URL + "/machine/component/setup";

//--------------- Assign Machine APIs-----------------------------------------
export const ASSIGN_MACHINE = BASE_BE_URL + "/machine/station/";
export const ASSIGN_MACHINE_SETUP = BASE_BE_URL + "/machine/station/setup";

//--------------- Site and Machine Remark  API--------------------------------
export const SITE_REMARK = BASE_BE_URL + "/station/remark";
export const MACHINE_REMARK = BASE_BE_URL + "/machine/remark";

//--------------- Unvisited Sites API-----------------------------------------
export const UNVISITED_SITES = BASE_BE_URL + "/station/inactive/1";

//--------------- Station Repair work done APIS--------------------------------
export const STATION_REPAIR_STEUP =
  BASE_BE_URL + "/station/setup-stationRepairWork";
export const CREATE_STATION_REPAIR = BASE_BE_URL + "/station/repair-work";
export const GET_STATION_REPAIR_WORK = BASE_BE_URL + "/station/repair-work/all";

// Deactivate Station API
export const DEACTIVATED_STATIONS =  BASE_BE_URL + "/station/all-deactivated";

// Material Transport
export const MATERIAL_TRANSPORT_SETUP = BASE_BE_URL + "/material-transport/setup"
export const ADD_MATERIAL_TRANSPORT = BASE_BE_URL + "/material-transport"
export const UPDATE_MATERIAL_TRANSPORT = BASE_BE_URL + "/material-transport/update"
export const GET_MATERIAL_TRANSPORT = BASE_BE_URL + "/material-transport/history"
export const DELETE_MATERIAL_TRANSPORT = BASE_BE_URL + "/material-transport/delete"